import React from 'react'
import { debounce } from 'lodash'

export default function useDeviceWidth({ debounceDelay = 70 } = {}) {
  const [width, setWidth] = React.useState(window.innerWidth)

  React.useEffect(() => {
    const listener = debounce(() => setWidth(window.innerWidth), debounceDelay)

    // Passive set to true.
    // This is promising the handler won't call preventDefault to disable resize.
    // This frees the browser up to respond to resizing immediately without
    // waiting for JavaScript, thus ensuring a reliably smooth resizing
    // experience for the user.
    window.addEventListener('resize', listener, { passive: true })

    // cleanup
    return () => {
      window.removeEventListener('resize', debounce)
      listener.cancel() // cancel debounce
    }
  }, [])

  return width
}
